<template>
  <div class="card border rounded-4 shadow-sm h-100 w-100">
    <div class="card-body p-3 p-lg-4 d-flex flex-column gap-4 h-100">
      <div class="d-flex flex-column gap-1">
        <h2 class="fw-bold text-x mb-0">Action Library</h2>
        <p class="text-secondary text-xs mb-0">
          Create reusable actions that can be used in transition rules and section access.
        </p>
      </div>

      <ActionForm
        :action-name="actionForm.action_name"
        :description="actionForm.description"
        :action-saving="actionSaving"
        :is-update="Boolean(actionForm.action_id)"
        :duplicate-warning="duplicateWarning"
        @update:actionName="$emit('update:actionName', $event)"
        @update:description="$emit('update:description', $event)"
        @save="$emit('save-action')"
        @reset="$emit('reset-action-form')"
      />

      <div class="card border rounded-4 shadow-sm">
        <div class="card-body p-3 workflow-soft-card">
          <p class="text-secondary text-xxs mb-0">
            Deleting an action may affect transition rules or section access that use it.
          </p>
        </div>
      </div>

      <div v-if="actionsLoading" class="text-secondary text-xs px-2">
        Loading actions...
      </div>

      <ActionList
        v-else
        :actions="workflowActions"
        :action-usage-by-id="actionUsageById"
        :action-delete-running-id="actionDeleteRunningId"
        @edit="$emit('edit-action', $event)"
        @delete="$emit('delete-action', $event)"
      />
    </div>
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
import ActionForm from './ActionForm.vue';
import ActionList from './ActionList.vue';

const registered_components = [ActionForm, ActionList];
void registered_components;

defineProps({
    actionsLoading: {
      type: Boolean,
      default: false,
    },
    actionSaving: {
      type: Boolean,
      default: false,
    },
    actionDeleteRunningId: {
      type: Number,
      default: null,
    },
    actionForm: {
      type: Object,
      default: () => ({
        action_id: null,
        action_name: '',
        description: '',
      }),
    },
    workflowActions: {
      type: Array,
      default: () => [],
    },
    actionUsageById: {
      type: Object,
      default: () => ({}),
    },
    duplicateWarning: {
      type: String,
      default: '',
    },
});

defineEmits([
    'update:actionName',
    'update:description',
    'save-action',
    'reset-action-form',
    'edit-action',
    'delete-action',
]);
</script>
